import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../services/api';
import './InquiryWrite.css';

const InquiryWrite = () => {
	const navigate = useNavigate();
	const [formData, setFormData] = useState({
		title: '',
		content: '',
		product_id: null
	});
	const [loading, setLoading] = useState(false);
	const [showProductModal, setShowProductModal] = useState(false);
	const [purchasedProducts, setPurchasedProducts] = useState([]);
	const [selectedProduct, setSelectedProduct] = useState(null);

	useEffect(() => {
		fetchPurchasedProducts();
	}, []);

	const fetchPurchasedProducts = async () => {
		try {
			const token = localStorage.getItem('access_token');
			console.log('🔑 토큰:', token);  // 디버그
			
			const response = await fetch(`${API_BASE_URL}/products/inquiries/purchased_products/`, {
				headers: { 
					'Authorization': `Bearer ${token}`,
					'Content-Type': 'application/json'
				}
			});
			
			console.log('📡 응답 상태:', response.status);  // 디버그
			
			if (response.ok) {
				const data = await response.json();
				console.log('📦 데이터:', data);  // 디버그
				setPurchasedProducts(data);
			}
		} catch (error) {
			console.error('구매 상품 목록 로딩 실패:', error);
		}
	};

	const handleChange = (e) => {
		setFormData({
			...formData,
			[e.target.name]: e.target.value
		});
	};

	const handleProductSelect = (product) => {
		setSelectedProduct(product);
		setFormData({
			...formData,
			product_id: product.id,
			title: `[상품문의] ${product.name}`
		});
		setShowProductModal(false);
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (!formData.title.trim()) {
			alert('제목을 입력해주세요.');
			return;
		}

		if (!formData.content.trim()) {
			alert('내용을 입력해주세요.');
			return;
		}

		setLoading(true);

		try {
			const token = localStorage.getItem('access_token');
			
			const response = await fetch(`${API_BASE_URL}/products/inquiries/`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token}`
				},
				body: JSON.stringify(formData)
			});
			
			if (response.status === 401) {
				alert('로그인이 필요합니다.');
				navigate('/login');
				return;
			}
			
			if (!response.ok) {
				const errorData = await response.json();
				throw new Error(errorData.error || '문의 등록 실패');
			}

			alert('문의가 등록되었습니다.');
			navigate('/inquiry');
		} catch (error) {
			console.error('문의 등록 실패:', error);
			alert(`문의 등록 실패: ${error.message}`);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="inquiry-write-container">
			<h1>💬 1:1 문의 작성</h1>

			<form onSubmit={handleSubmit} className="inquiry-form">
				<div className="form-group">
					<label>문의 유형 *</label>
					<div className="inquiry-type-buttons">
						<button
							type="button"
							className={`type-btn ${selectedProduct ? 'active' : ''}`}
							onClick={() => setShowProductModal(true)}
						>
							📦 구매상품 문의
						</button>
						<button
							type="button"
							className={`type-btn ${!selectedProduct ? 'active' : ''}`}
							onClick={() => {
								setSelectedProduct(null);
								setFormData({ ...formData, product_id: null, title: '' });
							}}
						>
							💭 일반 문의
						</button>
					</div>
				</div>

				{selectedProduct && (
					<div className="selected-product">
						<div className="product-info">
							<span className="status">{selectedProduct.status_display}</span>
							<h4>{selectedProduct.name}</h4>
							<p className="price">₩{Number(selectedProduct.price).toLocaleString()}</p>
						</div>
						<button
							type="button"
							className="btn-remove"
							onClick={() => {
								setSelectedProduct(null);
								setFormData({ ...formData, product_id: null, title: '' });
							}}
						>
							✕
						</button>
					</div>
				)}

				<div className="form-group">
					<label>제목 *</label>
					<input
						type="text"
						name="title"
						value={formData.title}
						onChange={handleChange}
						placeholder="제목을 입력하세요"
						maxLength={200}
					/>
				</div>

				<div className="form-group">
					<label>내용 *</label>
					<textarea
						name="content"
						value={formData.content}
						onChange={handleChange}
						placeholder="문의 내용을 상세히 입력해주세요"
						rows={10}
					/>
				</div>

				<div className="form-actions">
					<button 
						type="button" 
						onClick={() => navigate('/inquiry')}
						className="btn-cancel"
					>
						취소
					</button>
					<button 
						type="submit" 
						disabled={loading}
						className="btn-submit"
					>
						{loading ? '등록 중...' : '문의하기'}
					</button>
				</div>
			</form>

			{showProductModal && (
				<div className="modal-overlay" onClick={() => setShowProductModal(false)}>
					<div className="modal-content" onClick={(e) => e.stopPropagation()}>
						<div className="modal-header">
							<h3>구매 상품 선택</h3>
							<button 
								className="btn-close"
								onClick={() => setShowProductModal(false)}
							>
								✕
							</button>
						</div>
						<div className="modal-body">
							{purchasedProducts.length === 0 ? (
								<p className="empty-message">구매한 상품이 없습니다.</p>
							) : (
								<div className="product-list">
									{purchasedProducts.map((product, index) => (
										<div
											key={product.id}
											className="product-row"
											onClick={() => handleProductSelect(product)}
										>
											<span className="product-num">{index + 1}</span>
											<span className={`product-status ${product.status}`}>
												{product.status_display}
											</span>
											<span className="product-name">{product.name}</span>
											<span className="product-price">₩{Number(product.price).toLocaleString()}</span>
										</div>
									))}
								</div>
							)}
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default InquiryWrite;